import React, { useRef } from 'react'

function GalleryPopup({ data }) {
    const fancyboxRef = useRef();

    const openFancybox = (e) => {
        e.preventDefault()
        fancyboxRef.current.click();
    };

    const handleSubmit = (e) => {
        e.preventDefault()
    }

    return (
        <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="zx-portfolio">
                <div className="zx-inner">
                    <div className="side-viwe">
                        <div className="content-overlay"></div>
                        <a data-fancybox="gallery"
                            className='popup-gallery'
                            onClick={openFancybox}
                            ref={fancyboxRef}
                            href={data.href}
                        >
                            <img src={data.image} alt="portfolio" className="portfolio" />
                        </a>
                        <div className="content-details">
                            <a href='/' onClick={handleSubmit}><i className="fa-solid fa-link"></i></a>
                            <a href='/' onClick={openFancybox} className="popup-gallery pointer">
                                <i className="fa-solid fa-magnifying-glass"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GalleryPopup
